<template>
  <div class="check-item active">
    <div class="check-item__side -front">
      <div
        class="check-item__focus"
        :class="{'-active' : focusElementStyle }"
        :style="focusElementStyle"
        ref="focusElement"
      ></div>
      <div class="check-item__cover">
        <img
          v-if="currentCardBackground"
          :src="require('@/assets/images/' + currentCardBackground)"
          class="check-item__bg"
        />
      </div>
      <div class="check-item__wrapper">
        <div class="check-item__top">

          <img :src="require('@/assets/images/ach.png')" class="check-item__chip" style="opacity: .8; margin-top: 2px" />

          <div class="check-item__bank">

            <label :for="checkFields.bankName" class="check-item__bank" :ref="checkFields.bankName">

              <div class="check-item__holder">Bank Name</div>
              <transition name="slide-fade-up">
                <div class="check-item__name" v-if="labels.bankName.length" key="1">
                  <transition-group name="slide-fade-right">
                    <span class="check-item__nameItem"
                          v-for="(n, $index) in labels.bankName.replace(/\s\s+/g, ' ')"
                          :key="$index + 1">{{n}}</span>
                  </transition-group>
                </div>
                <div class="check-item__name" v-else key="2">Enter name of bank</div>
              </transition>
            </label>

            <!--<div class="check-item__amount">
              Twenty four dollars & <sup>99</sup>/<sub>100</sub>
            </div>-->

          </div>

          <div class="check-item__order">
            <!--{{selectedPlan.priceText}}-->
          </div>

        </div>

        <div class="check-item__content">
          <label :for="checkFields.routingNumber" class="check-item__info" :ref="checkFields.routingNumber">
            <div class="check-item__holder">Routing Number</div>
            <transition name="slide-fade-up">
              <div class="check-item__name" v-if="labels.routingNumber.length" key="1">
                <transition-group name="slide-fade-right">
                  <span class="check-item__nameItem"
                        v-for="(n, $index) in labels.routingNumber.replace(/\s\s+/g, ' ')"
                        :key="$index + 1">{{n}}</span>
                </transition-group>
              </div>
              <div class="check-item__name" v-else key="2">123456789</div>
            </transition>
          </label>

         

          <!--<label :for="checkFields.accountNumber" class="check-item__info" :ref="checkFields.accountNumber">
            <div class="check-item__holder">Account Number</div>
            <span v-for="(n, $index) in currentPlaceholder" :key="$index">
              <transition name="slide-fade-up">
                <div class="check-item__numberItem" v-if="getIsNumberMasked($index, n)">*</div>
                <div class="check-item__numberItem"
                     :class="{ '-active' : n.trim() === '' }"
                     :key="currentPlaceholder"
                     v-else-if="labels.accountNumber.length > $index">{{labels.accountNumber[$index]}}</div>
                <div class="check-item__numberItem"
                     :class="{ '-active' : n.trim() === '' }"
                     v-else
                     :key="currentPlaceholder + 1">{{n}}</div>
              </transition>
            </span>
          </label>-->

          <label :for="checkFields.accountNumber" class="check-item__info" :ref="checkFields.accountNumber">
            <div class="check-item__holder">Account Number</div>
            <transition name="slide-fade-up">
              <div class="check-item__name" v-if="labels.accountNumber.length" key="1">
                <transition-group name="slide-fade-right">
                  <span class="check-item__nameItem"
                        v-for="(n, $index) in labels.accountNumber.replace(/\s\s+/g, ' ')"
                        :key="$index + 1">{{n}}</span>
                </transition-group>
              </div>
              <div class="check-item__name" v-else key="2">123456789</div>
            </transition>
          </label>

        </div>
       
        
      </div>
    </div>
    
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
export default {
  name: 'Card',
  props: {
		labels: Object,
    
    checkFields: Object,
    isCardNumberMasked: Boolean,
    randomBackgrounds: {
      type: Boolean,
      default: true
    },
    backgroundImage: [String, Object]
  },
  data () {
    return {
      focusElementStyle: null,
      currentFocus: null,
      isFocused: false,
      isCardFlipped: false,
      amexCardPlaceholder: '#### ###### #####',
      dinersCardPlaceholder: '#### ###### ####',
      defaultCardPlaceholder: '#### #### #### ####',
      currentPlaceholder: ''
    }
  },
  watch: {
		currentFocus() {
			if (this.currentFocus) {
				this.changeFocus()
			} else {
				this.focusElementStyle = null
			}
		}
   
  },
  mounted () {
    this.changePlaceholder()

    let self = this
    let fields = document.querySelectorAll('[data-check-field]')
    fields.forEach(element => {
      element.addEventListener('focus', () => {
        this.isFocused = true
        if (element.id === this.checkFields.cardYear || element.id === this.checkFields.cardMonth) {
          this.currentFocus = 'cardDate'
        } else {
          this.currentFocus = element.id
        }
        this.isCardFlipped = element.id === this.checkFields.cardCvv
      })
      element.addEventListener('blur', () => {
        this.isCardFlipped = !element.id === this.checkFields.cardCvv
        setTimeout(() => {
          if (!self.isFocused) {
            self.currentFocus = null
          }
        }, 300)
        self.isFocused = false
      })
    })
  },
  computed: {
    ...mapGetters({
				selectedStudio: "selectedStudio",
				selectedPlan: "selectedPlan",
				locations: "locations",
				plans: "plans"
			}),
    currentCardBackground () {
      if (this.randomBackgrounds && !this.backgroundImage) { // TODO will be optimized
        let random = Math.floor(Math.random() * 25 + 1)
        return `${random}.jpeg`
      } else if (this.backgroundImage) {
        return this.backgroundImage
      } else {
        return null
      }
    }
  },
  methods: {
    changeFocus () {
      let target = this.$refs[this.currentFocus]
      this.focusElementStyle = target ? {
        width: `${target.offsetWidth}px`,
        height: `${target.offsetHeight}px`,
        transform: `translateX(${target.offsetLeft}px) translateY(${target.offsetTop}px)`
      } : null
    },
    getIsNumberMasked (index, n) {
      return index > 4 && index < 14 && this.labels.accountNumber.length > index && n.trim() !== '' && this.isAccountNumberMasked
    },
    changePlaceholder () {
     
    }
  }
}
</script>
